module.exports = __webpack_public_path__ + "static/fonts/PlayfairDisplay900.a20fb5c4.ttf";